import _ from "lodash";

// export function getNameByEmail(email: string) {
//   if (!email) return "Unknown";

//   const indexTo = email.indexOf("@");

//   const nickname = email.slice(0, indexTo).split(".").reverse().map(_.capitalize);

//   if (!nickname) return "Employee";

//   const shortNickname = `${nickname[0]} ${nickname[1][0]}.`;

//   return shortNickname;
// }

const emailRegex =
  /(i:0e\.t\|microsoftentratrust\||@abinbevefes\.com|@partnerabie\.com|@efescomm\.ru|@in4partners\.com)/g;

// export function emailFromAccountName(accountName: string){
//   email.slice(0, indexAt).replace(emailRegex, "")
// }

export function getNameAndSurname(str: string, email: string, short?: boolean) {
  if (!str) {
    if (short) {
      return shortNameFromEmail(email);
    } else {
      return nameFromEmail(email);
    }
  }

  const [FirstName, LastName] = str.trim().split(" ");

  if (short) {
    return FirstName && LastName ? `${_.capitalize(FirstName[0])}${_.capitalize(LastName[0])}` : "ND";
  }

  return `${FirstName || ""} ${LastName || ""}`;
}

export function nameFromEmail(email: string) {
  const indexAt = email.indexOf("@");

  if (indexAt !== -1) {
    const [FirstName, LastName] = email.slice(0, indexAt).replace(emailRegex, "").split(".");
    return `${FirstName ? _.capitalize(FirstName) : ""} ${LastName ? _.capitalize(LastName) : ""}`;
  } else {
    return "";
  }
}

export function shortNameFromEmail(email: string) {
  const [FirstName, LastName] = email.replace(emailRegex, "").split(".");

  return FirstName && LastName ? `${_.capitalize(FirstName[0])}${_.capitalize(LastName[0])}` : "ND";
}

export const prefix = "i:0e.t|microsoftentratrust|"; //! изменить, в случае изменения SP
// Функция для удаления префикса
export const removePrefix = (str: string, prefix: string) => {
  return str.startsWith(prefix) ? str.slice(prefix.length) : str;
};

export function mapArrayWithObject<T extends string | number | symbol>(array: Record<T, any>[], key: T) {
  return array.length > 0 ? array.map((item) => item[key]) : [];
}
